import { Box, Button, Grid, Paper } from '@mui/material';
import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { letterSpacing } from '@mui/system';
import AddIcon from '@mui/icons-material/Add';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Avatarimg from '../../assets/Images/DefaultAvatar.jpg';
import { Col } from 'react-bootstrap';
export const DesignerConnections = () => {
  return (
    <>
      <Box m="20px">
        <h4>Invitations</h4>

        <Paper
          elevation={4}
          style={{ padding: '5px', height: '280px', overflow: 'scroll' }}>
          <List
            sx={{
              width: '100%',
              maxWidth: '80%',
              bgcolor: 'background.paper',
            }}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar
                  alt="H"
                  src="/static/images/avatar/1.jpg"
                  sx={{ width: '50px', height: '50px' }}
                />
              </ListItemAvatar>
              <ListItemText
                variant="h3"
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: 'block' }}
                      component="div"
                      variant="h5"
                      color="text.primary">
                      Hardik Panwar
                    </Typography>
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="h7"
                      color="text.primary">
                      UI/UX designer
                    </Typography>
                    <div style={{ marginTop: '8px' }}>
                      <Button
                        variant="contained"
                        sx={{ fontSize: '9px', letterSpacing: 1 }}>
                        Accept
                      </Button>

                      <Button
                        variant="outlined"
                        sx={{
                          fontSize: '10px',
                          letterSpacing: 1,
                          marginLeft: '10px',
                        }}>
                        Ignore
                      </Button>
                    </div>
                  </React.Fragment>
                }
              />
            </ListItem>
            <Divider variant="inset" component="li" />
          </List>

          <List
            sx={{
              width: '100%',
              maxWidth: '80%',
              bgcolor: 'background.paper',
            }}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Avatar
                  alt="M"
                  src="/static/images/avatar/1.jpg"
                  sx={{ width: '50px', height: '50px' }}
                />
              </ListItemAvatar>
              <ListItemText
                variant="h3"
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: 'block' }}
                      component="div"
                      variant="h5"
                      color="text.primary">
                      Mayank yadav
                    </Typography>
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="h7"
                      color="text.primary">
                      Graphic Designer, Vector Artist
                    </Typography>
                    <div style={{ marginTop: '8px' }}>
                      <Button
                        variant="contained"
                        sx={{ fontSize: '9px', letterSpacing: 1 }}>
                        Accept
                      </Button>

                      <Button
                        variant="outlined"
                        sx={{
                          fontSize: '10px',
                          letterSpacing: 1,
                          marginLeft: '10px',
                        }}>
                        Ignore
                      </Button>
                    </div>
                  </React.Fragment>
                }
              />
            </ListItem>
            <Divider variant="inset" component="li" />
          </List>
        </Paper>

        <Box mt="20px">
          <h4>People you may know</h4>
          <Paper
            elevation={4}
            style={{ padding: '20px', height: '320px', overflow: 'scroll' }}>
            <Grid spacing={2} direction="column">
              <Card sx={{ maxWidth: 200 }}>
                <CardActionArea sx={{ textAlign: 'center' }}>
                  <img
                    src={Avatarimg}
                    style={{
                      width: 140,
                      height: 140,
                      borderRadius: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      John Doe
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Artist, Influencer
                      <div style={{ marginTop: '8px' }}>
                        <Button
                          variant="contained"
                          sx={{ fontSize: '9px', letterSpacing: 1 }}>
                          Connect +
                        </Button>
                      </div>
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          </Paper>
        </Box>
      </Box>
    </>
  );
};
